module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/plugins-185.vue");


//////////////////
// WEBPACK FOOTER
// ./en/vux-loader/plugins.md
// module id = 626
// module chunks = 413